<ngx-spinner *ngIf="loaderService.isLoading | async" bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#44a1a0" type = "ball-clip-rotate-multiple" [fullScreen] = "true">
	<p style="color: white" > Chargement... </p>
</ngx-spinner>
<router-outlet></router-outlet>